module.exports = __webpack_public_path__ + "static/img/logo.bb6d1593.png";